import { Checkbox as BaseCheckbox } from "antd"
import React from "react"

export function Checkbox(props: React.ComponentProps<typeof BaseCheckbox>) {
    return <BaseCheckbox {...props} />
}
